import { Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { presetPalettesGradient, presetPalettesPure, XcPalette } from '@gspwidget/util';

@Component({
  selector: 'epp-color-picker',
  templateUrl: './epp-color-picker.component.html',
  styleUrls: [`./epp-color-picker.component.scss`],
})
export class EppColorPickerComponent implements OnInit {

  /** 先留作兼容 */
  @Input() list: string[]
  /** 色板 */
  @Input() palettesPure: XcPalette[] = presetPalettesPure
  @Input() palettesGradient: XcPalette[] = presetPalettesGradient

  @Input() color: string = ''
  @Input() types: ('pure' | 'gradient')[] | string = ['gradient', 'pure']
  @Output() colorChange = new EventEmitter<string>();
  @ContentChild('colorBlock') colorBlock: TemplateRef<ElementRef>;

  constructor () {
  }
  ngOnInit () {

  }

  colorSelect (color: string) {
    this.color = color
    this.colorChange.emit(color)
  }

}
